import { Cookies } from "react-cookie";
import { COOKIES } from "../constants/misc";
const cookies = new Cookies();

export function getAuthIdParam(companyId?: string) {
    return companyId ? `a_i=${companyId}` : `a_i=${cookies.get(COOKIES.companyId)}`;
}
